import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

import importHolder from '../../../../api/blockchain/importHolder';

import { errorParser } from '../../../../components/LiquidForm/utils/errorParser';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import { snackbar } from '../../../../utilities/snackbarUtils';
import Input from '../../../../components/Form/Input';
import SubmitButton from '../../../../components/Form/SubmitButton';

const ImportAccountDialog = (props) => {
    const theme = useTheme();

    const schema = yup.object({
        gaid: yup.string().required('GAID is required.'),
    });

    const defaultValues = {
        gaid: '',
    };

    const {
        handleSubmit,
        control,
        reset,
        formState: { isSubmitting, errors },
    } = useForm({
        resolver: yupResolver(schema),
        defaultValues: defaultValues,
    });

    const importOne = async (data) => {
        await importHolder(props.user?.id, data.gaid)
            .then((response) => {
                snackbar.success(response.data.message);
                reset(defaultValues);
                props.handleClose();
            })
            .catch((error) => {
                snackbar.error(errorParser(error));
            });
    };

    return (
        <Dialog open={props.open} onClose={props.handleClose}>
            <DialogTitle>Import an existing account</DialogTitle>
            <form onSubmit={handleSubmit(importOne)}>
                <DialogContent>
                    <DialogContentText>
                        <div style={{ display: 'flex', color: theme.palette.text.secondary }}>
                            <Typography variant="body2">
                                Enter the holder's Green Account ID (GAID) to
                                import their account.
                            </Typography>
                        </div>
                        <br />
                        <Input
                            autoFocus
                            name="gaid"
                            label="GAID"
                            placeholder="Enter GAID"
                            type="text"
                            fullWidth
                            error={errors?.gaid}
                            control={control}
                            variant="outlined"
                        />
                        <br />
                        <br />
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.handleClose}>Cancel</Button>
                    <SubmitButton
                        text="Import"
                        disabled={isSubmitting}
                        loading={isSubmitting}
                    />
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default ImportAccountDialog;
